import { Injectable } from '@angular/core';
@Injectable()
export class ProgramUtilityService {

  constructor() { }

  getColor(outcome) {
    switch (outcome) {
      case 'EXCEPTION':
        return 'orange';
      case 'REJECTION':
        return 'red';
      case 'ONHOLD':
        return '#86be25';
        case 'NONE':
          return 'white';
    }
  }
  getRuleOutcome(outcome) {
    switch (outcome) {
      case 'EXCEPTION':
        return 'EXCEPTION';
      case 'REJECTION':
        return 'REJECTION';
      case 'ONHOLD':
        return 'ON HOLD';
        case 'NONE':
          return 'NONE';
    }
  }
}